import { defineLocale } from "../../registry";

const reference = defineLocale({
  ru: {
    "reference.categories.title": "Категории",
    "reference.icons.title": "Иконки",
    "reference.categories.empty": "Категорий пока нет",
    "reference.icons.empty": "Иконок пока нет",
    "reference.col.key": "Ключ",
    "reference.col.label": "Подпись",
    "reference.col.preview": "Иконка",
    "reference.col.actions": "Действия",
    "reference.add": "Добавить категорию",
    "reference.edit": "Изменить",
    "reference.editNamed": "Изменить {name}",
    "reference.remove": "Убрать",
    "reference.removeNamed": "Убрать {name}",
    "reference.form.add": "Добавить категорию",
    "reference.form.edit": "Изменить категорию",
    "reference.field.key": "Ключ",
    "reference.field.label": "Подпись",
    "reference.error.required": "Заполните поле",
    "reference.error.duplicate": "Этот ключ уже занят",
    "reference.remove.title": "Убрать категорию",
    "reference.remove.body": "Категория «{name}» будет убрана из справочника.",
    "reference.remove.accept": "Убрать",
    "reference.saved": "Сохранено",
    "reference.removed": "Категория убрана",
    "reference.conflict.hint":
      "Справочник изменили с другого экрана. Перезагрузите его и повторите правку.",
    "reference.inUse.title": "Запись используется",
    "reference.inUse.count": "Pick, использующих запись: {count}",
    "reference.inUse.unknown": "Запись используется в Pick",
    "reference.inUse.hint": "Её нельзя изменить или убрать, пока она используется.",
    "reference.inUse.link": "Показать Pick в каталоге",
    "reference.icons.readonly":
      "Реестр иконок закрыт: он зашит в консоль и здесь не редактируется.",
    "reference.icon.unregistered": "Нет в реестре консоли",
  },
  en: {
    "reference.categories.title": "Categories",
    "reference.icons.title": "Icons",
    "reference.categories.empty": "No categories yet",
    "reference.icons.empty": "No icons yet",
    "reference.col.key": "Key",
    "reference.col.label": "Label",
    "reference.col.preview": "Icon",
    "reference.col.actions": "Actions",
    "reference.add": "Add category",
    "reference.edit": "Edit",
    "reference.editNamed": "Edit {name}",
    "reference.remove": "Remove",
    "reference.removeNamed": "Remove {name}",
    "reference.form.add": "Add category",
    "reference.form.edit": "Edit category",
    "reference.field.key": "Key",
    "reference.field.label": "Label",
    "reference.error.required": "Fill in this field",
    "reference.error.duplicate": "This key is already in use",
    "reference.remove.title": "Remove category",
    "reference.remove.body": "The category \"{name}\" will be removed from the reference.",
    "reference.remove.accept": "Remove",
    "reference.saved": "Saved",
    "reference.removed": "Category removed",
    "reference.conflict.hint":
      "The reference was changed elsewhere. Reload it and repeat your edit.",
    "reference.inUse.title": "This entry is in use",
    "reference.inUse.count": "Picks using this entry: {count}",
    "reference.inUse.unknown": "Picks still use this entry",
    "reference.inUse.hint":
      "It cannot be changed or removed while it is in use.",
    "reference.inUse.link": "Show these picks in the catalog",
    "reference.icons.readonly":
      "The icon registry is closed: it ships with the console and cannot be edited here.",
    "reference.icon.unregistered": "Not in the console registry",
  },
});

export default reference;
